<template>
  <el-form
    ref="tlFormRefs"
    class="tl-form"
    :model="form"
    :rules="rules"
    :disabled="disabled"
    :label-width="labelWidth"
    :label-position="labelPosition"
  >
    <el-row :gutter="10">
      <el-col
        v-for="(item, index) in options"
        :key="item.prop + index"
        :span="item.span"
      >
        <slot v-if="item.formTemplate" :name="item.formTemplate" :item="item" />
        <el-form-item
          v-else-if="item.template"
          :label="item.label"
          :prop="item.prop"
        >
          <slot :name="item.template" :item="item" />
        </el-form-item>
        <TlFormItem v-else v-model="form" :item="item" />
      </el-col>
    </el-row>
  </el-form>
</template>
<script setup>
import TlFormItem from "./TlFormItem.vue";
const tlFormRefs = ref(null);
defineProps({
  disabled: {
    type: [Boolean, Number],
    default: false
  },
  labelWidth: {
    type: [String, Number],
    default: "auto"
  },
  labelPosition: {
    type: String,
    default: "right"
  }
});
const form = defineModel({
  delete: () => {
    return {};
  }
});
const rules = defineModel("rules", {
  delete: () => {
    return {};
  }
});
const options = defineModel("options", {
  delete: () => {
    return [];
  }
});
const validate = fun => {
  return tlFormRefs.value.validate((valid, fields) => {
    if (valid) {
      fun(valid);
    }
  });
};
// 重置
defineExpose({
  ref: tlFormRefs,
  validate
});
</script>
<style scoped lang="scss"></style>
